import { CloudDownloadOutlined, PlusOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal, Vertical } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Upload } from 'antd'
import moment from 'moment'
import { useState } from 'react'

type FooterProps = {
  canEditOrderMovements: boolean
  bol: Gravitate.BolObject | undefined
  onCancel: () => void
  onUploadImage: (file: File) => Promise<void>
  isImageUploading?: boolean
  hasImages: boolean
}

export function Footer({
  canEditOrderMovements,
  bol,
  onCancel,
  onUploadImage,
  isImageUploading,
  hasImages,
}: FooterProps) {
  const [imagesDownloading, setImagesDownloading] = useState(false)

  async function downloadBOLImage() {
    try {
      setImagesDownloading(true)
      const resp = await api.getBOLImagePDF(bol?.key)
      const url = window.URL.createObjectURL(new Blob([resp.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `BOL#${bol?.number}-${formatters.DATE(moment(bol?.date))}.pdf`)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.error('Error downloading BOL image:', error)
    } finally {
      setImagesDownloading(false)
    }
  }

  return (
    <>
      {canEditOrderMovements && (
        <Vertical>
          <Horizontal justifyContent='space-between' verticalCenter>
            <Upload accept='image/*,.pdf' beforeUpload={onUploadImage} showUploadList={false}>
              <GraviButton icon={<PlusOutlined />} buttonText='Add Attachment' loading={isImageUploading} />
            </Upload>
            <Horizontal className='p-3' justifyContent='flex-end'>
              <GraviButton buttonText='Close' onClick={() => onCancel()} className='mr-3' />
              <GraviButton
                disabled={!hasImages}
                icon={<CloudDownloadOutlined />}
                onClick={downloadBOLImage}
                loading={imagesDownloading}
                buttonText='Download'
                theme2
              />
            </Horizontal>
          </Horizontal>
        </Vertical>
      )}
    </>
  )
}
